import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CustomCard from "../components/Card";
import PageSection from "../components/page/Section";
import TemplatePage from "./TemplatePage";
import SwitchImage from "../assets/figmaexports/switchimage.png";
import SwitchGradient from "../assets/figmaexports/switchgradient.png";

const header = {
  style: {
    fontFamily: "abnes",
    fontSize: "48px",
    color: "white",
    lineHeight: "1em",
  },
};

const headerSubtitles = {
  style: {
    fontFamily: "poppins",
    fontWeight: "300",
    fontSize: "20px",
    color: "white",
    lineHeight: "1em",
  },
};

const subtitles = {
  style: {
    fontFamily: "poppins",
    fontWeight: "600",
    fontSize: "30spx",
    color: "white",
    lineHeight: "1em",
  },
};

const header2 = {
  style: {
    fontFamily: "poppins",
    fontWeight: "700",
    fontSize: "52px",
    color: "white",
    lineHeight: "1em",
  },
};

const header3 = {
  style: {
    fontFamily: "poppins",
    fontWeight: "700",
    fontSize: "23px",
    color: "#87D0D0",
    lineHeight: "1em",
  },
};

const FirstSection = () => {
  return (
    <PageSection>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack width="50%" spacing={4}>
          <Typography {...header}>Lorem ipsum dolor sit amet,</Typography>
          <Typography {...headerSubtitles}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Typography>
          <Box>
            <Stack direction="row" spacing={3}>
              <Link to="/tokens-exchange" style={{ textDecoration: "none" }}>
                <Button
                  sx={{
                    background:
                      "linear-gradient(277.72deg, #78AFCF -2.06%, #8FDDD9 90.6%)",
                    borderRadius: "50px",
                    paddingX: "30px",
                    paddingY: "10px",
                  }}
                >
                  BUY NFTS
                </Button>
              </Link>
              <Button
                variant="outlined"
                sx={{
                  borderRadius: "50px",
                  borderColor: "#87D0D0",
                  paddingX: "30px",
                  paddingY: "10px",
                }}
              >
                SELL NFTS
              </Button>
            </Stack>
          </Box>
        </Stack>
        <Box
          width="40%"
          //   sx={{
          //     backgroundImage: `url(${SwitchGradient})`,
          //     backgroundSize: "100%",
          //     boxShadow: "0 0 40px 40px #101011 inset",
          //   }}
        >
          <img
            src={SwitchImage}
            alt="switch image"
            style={{
              maxWidth: "100%",
            }}
          />
        </Box>
      </Stack>
    </PageSection>
  );
};

const SecondSection = () => {
  return (
    <PageSection>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Box
          width="40%"
          //   sx={{
          //     backgroundImage: `url(${SwitchGradient})`,
          //     backgroundSize: "100%",
          //     boxShadow: "0 0 40px 40px #101011 inset",
          //   }}
        ></Box>
        <Stack width="50%" spacing={4}>
          <Stack>
            <Typography {...header3}>Lorem ipsum</Typography>
            <Typography {...header2}>Lorem ipsum dolor sit amet,</Typography>
          </Stack>
          <Typography {...headerSubtitles}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Typography>
        </Stack>
      </Stack>
    </PageSection>
  );
};

const ThirdSection = () => {
  return (
    <PageSection>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack width="50%" spacing={4}>
          <Stack>
            <Typography {...header3}>Lorem ipsum</Typography>
            <Typography {...header2}>Lorem ipsum dolor sit amet,</Typography>
          </Stack>
          <Typography {...headerSubtitles}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Typography>
        </Stack>
        <Box
          width="40%"
          //   sx={{
          //     backgroundImage: `url(${SwitchGradient})`,
          //     backgroundSize: "100%",
          //     boxShadow: "0 0 40px 40px #101011 inset",
          //   }}
        ></Box>
      </Stack>
    </PageSection>
  );
};

const Collection = () => {
  return (
    <>
      <PageSection>
        <Stack spacing={2}>
          <Typography {...subtitles}>View Existing Collections</Typography>
          <CustomCard />
        </Stack>
      </PageSection>
    </>
  );
};

const Offers = () => {
  return (
    <>
      <PageSection>
        <Box
          height="300px"
          sx={{
            borderRadius: "40px",
            background:
              "linear-gradient(179.6deg, rgba(176, 255, 250, 0.666562) 0.34%, rgba(128, 255, 247, 0) 99.66%)",
          }}
        >
          <Typography>Popular and Affordable Collections</Typography>
        </Box>
      </PageSection>
    </>
  );
};

function Landing() {
  return (
    <TemplatePage>
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <Collection />
      <Offers />
    </TemplatePage>
  );
}

export default Landing;
